import { AccordionDetails, Box, styled, Typography } from '@mui/material';
import { DynamicTooltipChip } from 'src/components/dynamicTooltipChip/DynamicTooltipChip';

export const AssemblyTitle = styled(Typography)(
  ({ theme }) => `
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.125rem;
    display: flex;
    align-items: center;
    height: 1.1875rem;
    color:${theme.palette.secondary.dark};
    padding-bottom: 1.25rem;
     padding-top: 1.625rem;
  `,
);

export const AssemblyInfoTitle = styled(Typography)(
  ({ theme }) => `
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.125rem;
    display: flex;
    color:${theme.palette.secondary.dark};
    padding-bottom: 0.125rem;
  `,
);

export const AssemblyInfoText = styled(Typography)(
  ({ theme }) => `
    font-weight: 300;
    font-size: 1rem;
    font-style: normal;
    line-height: 1.125rem;
    align-items: center;
    color:${theme.palette.secondary.dark};
    padding-bottom: 1.25rem;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
);

export const ChipContainer = styled(Typography)`
  display: inline-flex;
  align-items: center;
`;

export const AssemblyChipStyle = styled(Box)`
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 1.25rem;
  gap: 10px;
`;

export const AlertContainer = styled(Box)`
  padding: 0px;
  margin-right: 1.25rem;
`;

export const AssemblyDetails = styled(AccordionDetails)`
  min-height: 1rem;
  padding: 1rem;
`;

export const StyledTypography = styled(Typography)`
  font-size: 1rem;
  font-weight: 400;
`;

export const StyledBox = styled(Box)`
  display: flex,
  justify-content: left,
  align-items: left,
`;

export const SummaryLabel = styled(Typography)(
  () => `
        font-weight: 500;
        font-size: 1rem;
    `,
);

export const StyledChipContainer = styled(Box)`
  margin: 5px 5px 5px 0;
  display: inline-block;
`;

export const StyledDynamicTooltipChip = styled(DynamicTooltipChip)`
  max-width: 272px;
`;
